import { getAxiosInstance } from '../../configs/axios-config';
import { authDetails } from '../../helpers/auth-details';
var constants = require("../../configs/constants");
const ADD_GALLERY_DETAILS_PROGRESS = "ADD_GALLERY_DETAILS_PROGRESS";
const ADD_GALLERY_DETAILS_SUCCESS = "ADD_GALLERY_DETAILS_SUCCESS";
const ADD_GALLERY_DETAILS_FAILURE = "ADD_GALLERY_DETAILS_FAILURE";
const GET_ALBUM_DETAILS_SUCCESS = "GET_ALBUM_DETAILS_SUCCESS";
const GET_ALBUM_DETAILS_FAILURE = "GET_ALBUM_DETAILS_FAILURE";
const ADD_PHOTO_SUCCESS = "ADD_PHOTO_SUCCESS";
const ADD_PHOTO_FAILURE = "ADD_PHOTO_FAILURE";
const SEND_GALLERY_CASE = "SEND_GALLERY_CASE";
const DELETE_GALLERY_IMAGE_SUCCESS = "DELETE_GALLERY_IMAGE_SUCCESS";
const DELETE_GALLERY_DATA_SUCCESS = "DELETE_GALLERY_DATA_SUCCESS";
const DELETE_DATA_PROGRESS = "DELETE_DATA_PROGRESS";
const DELETE_GALLERY_DATA_FAILURE = "DELETE_GALLERY_DATA_FAILURE";
const HIDE_GALLERY_SNACKBAR = "HIDE_GALLERY_SNACKBAR";
const OPEN_MODAL = "OPEN_MODAL";
const OPEN_MODAL_TWO = "OPEN_MODAL_TWO";
const OPEN_MODAL_THREE = "OPEN_MODAL_THREE";
const GET_IMAGES_SUCCESS = "GET_IMAGES_SUCCESS";
const GET_IMAGES_FAILURE = "GET_IMAGES_FAILURE";
const LOADING_GALLERY_IN_PROGRESS = "LOADING_GALLERY_IN_PROGRESS";

export const hideSnackBarAction = () => { return { type: HIDE_GALLERY_SNACKBAR } }
export const loadingInProgress = () => { return { type: LOADING_GALLERY_IN_PROGRESS } }
export const addGalleryDetailsInProgress = (aboutUsData) => { return { type: ADD_GALLERY_DETAILS_PROGRESS, aboutUsData: aboutUsData } }
export const addGalleryDetailsSuccess = (successMessage) => { return { type: ADD_GALLERY_DETAILS_SUCCESS, message: successMessage } }
export const addGalleryDetailsFailure = (errorMessage) => { return { type: ADD_GALLERY_DETAILS_FAILURE, message: errorMessage } }
export const getAlbumDetailsSuccess = (albumData) => { return { type: GET_ALBUM_DETAILS_SUCCESS, albumData: albumData } }
export const getAlbumDetailsFailure = (errorMessage) => { return { type: GET_ALBUM_DETAILS_FAILURE, message: errorMessage } }
export const getGalleryImgSuccess = (images) => { return { type: GET_IMAGES_SUCCESS, images: images } }
export const getGalleryImgFailure = (errorMessage) => { return { type: GET_IMAGES_FAILURE, message: errorMessage } }
export const returnSwitch = (caseData, imageDetail) => { return { type: SEND_GALLERY_CASE, caseData: caseData, imageDetail: imageDetail } }
export const addPhotoSuccess = (photoUrl, successMsg) => { return { type: ADD_PHOTO_SUCCESS, photoUrl: photoUrl, successMsg: successMsg } }
export const addPhotoFailure = (errorMsg) => { return { type: ADD_PHOTO_FAILURE, message: errorMsg } }
export const deleteAlbumDetailsProgress = () => { return { type: DELETE_DATA_PROGRESS } }
export const deleteGalleryImageSuccess = (successMsg) => { return { type: DELETE_GALLERY_IMAGE_SUCCESS, message: successMsg } }
export const deleteAlbumDetailsSuccess = (successMsg) => { return { type: DELETE_GALLERY_DATA_SUCCESS, message: successMsg } }
export const deleteAlbumDetailsFailure = (errorMsg) => { return { type: DELETE_GALLERY_DATA_FAILURE, message: errorMsg } }
export const returnModal = (modalCase, album) => { return { type: OPEN_MODAL, modalCase: modalCase, album: album } }
export const returnModalTwo = (modalDes, albumDec) => { return { type: OPEN_MODAL_TWO, modalDes: modalDes, albumDec: albumDec } }
export const returnModalThree = (deleteCase, album) => { return { type: OPEN_MODAL_THREE, deleteCase: deleteCase, album: album } }

// RENDER THE COMPONENT USING SWITCH CASE
export const renderSwitch = (caseData, imageDetail) => (dispatch) => {
    dispatch(returnSwitch(caseData, imageDetail));
};

// RENDER MODAL 
export const openModal = (modalCase, album) => (dispatch) => {
    dispatch(returnModal(modalCase, album));
};

// RENDER Delete album MODAL 
export const openModalThree = (deleteCase, album) => (dispatch) => {
    dispatch(returnModalThree(deleteCase, album));
};

// RENDER MODAL 
export const openModalTwo = (modalDes, albumDec) => (dispatch) => {
    dispatch(returnModalTwo(modalDes, albumDec));
};

// HIDE THE MESSAGE SNACKBAR
export const hideSnackBar = () => (dispatch) => {
    dispatch(hideSnackBarAction());
}

// upload the image 
export const uploadFile = (image) => (dispatch) => {
    dispatch(loadingInProgress());
    let bodyFormData = new FormData();
    bodyFormData.append('file', image.image);
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }

    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.UPLOAD, bodyFormData, config
    ).then(function (response) {
        dispatch(addPhotoSuccess(response.data.secureUrl, "फोटो यशस्वीरित्या अपलोड केला आहे"));
    }).catch(function (error) {
        dispatch(addPhotoFailure(error.message));
    });
};

// get all images by albumId
export const viewGalleryImages = (albumId) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    return axiosInstance.get(constants.api.GALLERY + '/' + albumId + '/' + user._id, {
    }).then(function (response) {
        dispatch(getGalleryImgSuccess(response.data));
    }).catch(function (error) {
        dispatch(getGalleryImgFailure(error.message));
    });
};

// get Album details
export const albumDetails = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    return axiosInstance.get(constants.api.ALBUM + '/' + user._id + '/' + data.perpage + '/' + data.page, {
    }).then(function (response) {
        dispatch(getAlbumDetailsSuccess(response.data));
    }).catch(function (error) {
        dispatch(getAlbumDetailsFailure(error.message));
    });
};

//post Album details
export const addAlbum = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    dispatch(addGalleryDetailsInProgress(data));
    return axiosInstance.post(constants.api.ALBUM, {
        albumName: data.albumName,
        discription: data.discription,
        addedBy: user._id,
        societyId: user._id
    }).then(function (response) {
        dispatch(addGalleryDetailsSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(addGalleryDetailsFailure(error.response.data.message));
    });
}

// post gallery details
export const addGalleryImg = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    dispatch(addGalleryDetailsInProgress(data));
    return axiosInstance.post(constants.api.GALLERY, {
        albumId: data.albumId,
        image: data.image,
        addedBy: user._id,
        societyId: user._id
    }).then(function (response) {
        dispatch(addGalleryDetailsSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(addGalleryDetailsFailure(error.response.data.message));
    });
};

// delete album details by album
export const deleteAlbum = (albumId) => (dispatch) => {
    let axiosInstance = getAxiosInstance();
    dispatch(deleteAlbumDetailsProgress());
    return axiosInstance.patch(constants.api.ALBUM, {
        albumId: albumId
    }).then(function (response) {
        dispatch(deleteAlbumDetailsSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(deleteAlbumDetailsFailure(error.message));
    });
};

// delete album under the only one image
export const deleteGallery = (imageId) => (dispatch) => {
    let axiosInstance = getAxiosInstance();
    dispatch(deleteAlbumDetailsProgress());
    return axiosInstance.patch(constants.api.GALLERY, {
        imageId: imageId
    }).then(function (response) {
        dispatch(deleteGalleryImageSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(deleteAlbumDetailsFailure(error.message));
    });
}

export const initialState = {
    inProgress: false,
    message: '',
    open: false,
    modal: false,
    modalTwo: false,
    albumData: [],
    images: [],
    choice: 'table',
    imageDetail: '',
    album: '',
    albumDec: '',
    photoUrl: '',
    add: false,
    delete: false,
    deleteCase: false,
    imgDelete: false,
    loading: false,
    totalRowsCount: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_GALLERY_DETAILS_PROGRESS:
            return { ...state, inProgress: true };
        case ADD_GALLERY_DETAILS_SUCCESS:
            return { ...state, message: action.message, inProgress: false, modal: false, open: true, choice: 'table', add: true, photoUrl: '' };
        case ADD_GALLERY_DETAILS_FAILURE:
            return { ...state, message: action.message, inProgress: false, open: true };
        case GET_ALBUM_DETAILS_SUCCESS:
            return { ...state, albumData: action.albumData.dataList, totalRowsCount: action.albumData.totalItems, add: false, delete: false };
        case GET_ALBUM_DETAILS_FAILURE:
            return { ...state, message: action.message };
        case GET_IMAGES_SUCCESS:
            return { ...state, images: action.images, choice: 'view', imgDelete: false };
        case GET_IMAGES_FAILURE:
            return { ...state, message: action.message };
        case DELETE_GALLERY_DATA_SUCCESS:
            return { ...state, message: action.message, open: true, delete: true, deleteCase: false };
        case DELETE_GALLERY_IMAGE_SUCCESS:
            return { ...state, message: action.message, open: true, imgDelete: true };
        case DELETE_GALLERY_DATA_FAILURE:
            return { ...state, message: action.message, open: true };
        case LOADING_GALLERY_IN_PROGRESS:
            return { ...state, loading: true };
        case ADD_PHOTO_SUCCESS:
            return { ...state, photoUrl: action.photoUrl, message: action.successMsg, open: true, add: true, loading: false };
        case SEND_GALLERY_CASE:
            return { ...state, choice: action.caseData, imageDetail: action.imageDetail };
        case HIDE_GALLERY_SNACKBAR:
            return { ...state, open: false };
        case OPEN_MODAL:
            return { ...state, modal: action.modalCase, album: action.album };
        case OPEN_MODAL_TWO:
            return { ...state, modalTwo: action.modalDes, albumDec: action.albumDec };
        case OPEN_MODAL_THREE:
            return { ...state, deleteCase: action.deleteCase, album: action.album };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/society/gallery-reducer.js